import React, { useState } from 'react';
import { TopBar } from '../components/layout/TopBar';
import { Header } from '../components/layout/Header';
import { Navigation } from '../components/layout/Navigation';
import { Footer } from '../components/layout/Footer';
import { ProductGallery } from '../components/product/ProductGallery';
import { ProductInfo } from '../components/product/ProductInfo';
import { ProductDescription } from '../components/product/ProductDescription';
import { RelatedProducts } from '../components/product/RelatedProducts';
import { Phone, ShoppingCart, FileText } from 'lucide-react';
export function ProductDetail() {
  const [options, setOptions] = useState({
    selectedColor: 'Dark Bronze',
    selectedId: 'Standard Decal ID',
    sequence: '',
    reviewRequested: false
  });
  return <div className="min-h-screen flex flex-col bg-white pb-24 lg:pb-0" data-id="element-604">
      <TopBar data-id="element-605" />
      <Header data-id="element-606" />
      <Navigation data-id="element-607" />

      <main className="flex-grow py-8 lg:py-12" data-id="element-608">
        <div className="max-w-7xl mx-auto px-4" data-id="element-609">
          {/* Breadcrumbs */}
          <nav className="flex text-sm text-gray-500 mb-8 overflow-x-auto hide-scrollbar whitespace-nowrap pb-2" data-id="element-610">
            <ol className="flex items-center space-x-2" data-id="element-611">
              <li data-id="element-612">
                <a href="/Home.html" className="hover:text-brand-green transition-colors" data-id="element-613">
                  Home
                </a>
              </li>
              <li data-id="element-614">
                <span data-id="element-615">/</span>
              </li>
              <li data-id="element-616">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-brand-green transition-colors" data-id="element-617">
                  Commercial Mailboxes & Lockers
                </a>
              </li>
              <li data-id="element-618">
                <span data-id="element-619">/</span>
              </li>
              <li data-id="element-620">
                <a href="/6m8/commercial-mailboxes-lockers/centralized-delivery-mailboxes-kiosks.html" className="hover:text-brand-green transition-colors" data-id="element-621">
                  Centralized Delivery Mailboxes & Kiosks
                </a>
              </li>
              <li data-id="element-622">
                <span data-id="element-623">/</span>
              </li>
              <li className="text-brand-charcoal font-medium truncate max-w-[200px] sm:max-w-none" data-id="element-624">
                Versatile 4C Depot 16H - 20 Door Package
              </li>
            </ol>
          </nav>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 relative" data-id="element-625">
            {/* Left Column: Gallery & Details */}
            <div className="lg:col-span-8" data-id="element-626">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:block" data-id="element-627">
                <div className="lg:hidden mb-8" data-id="element-628">
                  <ProductGallery data-id="element-629" />
                </div>

                <div className="hidden lg:block mb-12 max-w-2xl" data-id="element-630">
                  <ProductGallery data-id="element-631" />
                </div>

                <div className="lg:hidden" data-id="element-632">
                  <ProductInfo onOptionsChange={setOptions} data-id="element-633" />
                </div>
              </div>

              <ProductDescription data-id="element-634" />
              <RelatedProducts data-id="element-635" />
            </div>

            {/* Right Column: Info & Sticky Summary (Desktop) */}
            <div className="hidden lg:block lg:col-span-4" data-id="element-636">
              <ProductInfo onOptionsChange={setOptions} data-id="element-637" />

              {/* Sticky Summary Panel (Desktop) */}
              <div className="sticky top-32 mt-12 bg-brand-cream rounded-xl border border-brand-border p-6 shadow-sm" data-id="element-638">
                <h3 className="font-serif font-bold text-xl text-brand-charcoal mb-4 border-b border-brand-border pb-4" data-id="element-639">
                  Order Summary
                </h3>

                <div className="space-y-3 text-sm mb-6" data-id="element-640">
                  <div className="flex justify-between" data-id="element-641">
                    <span className="text-gray-600" data-id="element-642">Color:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-643">
                      {options.selectedColor}
                    </span>
                  </div>
                  <div className="flex justify-between" data-id="element-644">
                    <span className="text-gray-600" data-id="element-645">Door ID:</span>
                    <span className="font-medium text-brand-charcoal" data-id="element-646">
                      {options.selectedId}
                    </span>
                  </div>
                  {options.sequence && <div className="flex justify-between" data-id="element-647">
                      <span className="text-gray-600" data-id="element-648">Sequence:</span>
                      <span className="font-medium text-brand-charcoal truncate max-w-[150px]" data-id="element-649">
                        {options.sequence}
                      </span>
                    </div>}
                  <div className="flex justify-between pt-3 border-t border-brand-border/50" data-id="element-650">
                    <span className="text-gray-600" data-id="element-651">Review Requested:</span>
                    <span className={`font-bold ${options.reviewRequested ? 'text-brand-green' : 'text-gray-400'}`} data-id="element-652">
                      {options.reviewRequested ? 'Yes' : 'No'}
                    </span>
                  </div>
                </div>

                <div className="text-3xl font-bold text-brand-green mb-6 text-center" data-id="element-653">
                  $4,353.00
                </div>

                <div className="space-y-3" data-id="element-654">
                  {options.reviewRequested ? <button className="w-full bg-brand-green hover:bg-brand-green/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-655">
                      <FileText size={18} data-id="element-656" /> Request Review
                    </button> : <button className="w-full bg-brand-red hover:bg-brand-red/90 text-white py-3.5 rounded-md font-bold transition-colors flex items-center justify-center gap-2 shadow-sm" data-id="element-657">
                      <ShoppingCart size={18} data-id="element-658" /> Add to Cart
                    </button>}
                  <a href="tel:301-620-7585" className="w-full bg-white border border-brand-border hover:border-brand-green text-brand-charcoal py-3 rounded-md font-bold transition-colors flex items-center justify-center gap-2" data-id="element-659">
                    <Phone size={18} data-id="element-660" /> Call 301-620-7585
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-661" />

      {/* Mobile Sticky Bottom Bar (Product Specific) */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-brand-border shadow-[0_-10px_20px_rgba(9,46,37,0.05)] z-50 p-4 pb-safe flex items-center gap-3" data-id="element-662">
        <div className="flex-1" data-id="element-663">
          <div className="text-xs text-gray-500 font-medium" data-id="element-664">Total</div>
          <div className="text-lg font-bold text-brand-green leading-none" data-id="element-665">
            $4,353.00
          </div>
        </div>
        <a href="#configure-options" className="bg-brand-charcoal text-white px-6 py-2.5 rounded-md font-bold text-sm" data-id="element-666">
          Configure
        </a>
        <a href="/ContactUs.html" className="bg-brand-green text-white px-4 py-2.5 rounded-md font-bold text-sm flex items-center justify-center" data-id="element-667">
          Help
        </a>
      </div>
    </div>;
}